export default "__VITE_ASSET__6a31a0b6__"